import React from 'react'
import ReactDOM from 'react-dom/client'
import App from './App'
import './styles/variables.css'
import './styles/global.css'

// Keep the browser console quiet for visitors (including failed form submissions).
const noop = () => {}
console.log = noop
console.debug = noop
console.info = noop
console.warn = noop
console.error = noop
console.table = noop
console.dir = noop
console.trace = noop
console.group = noop
console.groupCollapsed = noop
console.groupEnd = noop

ReactDOM.createRoot(document.getElementById('root')!).render(
  <React.StrictMode>
    <App />
  </React.StrictMode>,
)
